var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuanturama01010001(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 2.04 2.04",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-alien",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1155") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "#9ca3af",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.082 0.017c-0.463 0 -0.838 0.357 -0.838 0.798C0.244 1.256 0.865 1.92 1.082 1.92 1.299 1.92 1.92 1.256 1.92 0.815 1.92 0.375 1.545 0.017 1.082 0.017M0.947 1.307c-0.038 0.038 -0.17 -0.033 -0.294 -0.159C0.529 1.023 0.459 0.89 0.497 0.852c0.038 -0.039 0.169 0.032 0.294 0.158 0.124 0.126 0.194 0.259 0.156 0.297m0.266 -0.001c-0.038 -0.038 0.032 -0.171 0.159 -0.297 0.126 -0.126 0.259 -0.196 0.298 -0.158 0.038 0.038 -0.033 0.171 -0.158 0.296 -0.126 0.126 -0.259 0.196 -0.298 0.158",
    fill: "#9ca3af",
    className: "si-glyph-fill"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuanturama01010001);
export default __webpack_public_path__ + "static/media/quanturama-01010001.6e1052256323545e4d486c9dd7c18f98.svg";
export { ForwardRef as ReactComponent };